import axios from "axios"
import { isBrowser, isMobile as _isMobile } from "@/libs/helpers"

/**
 * Gets the quality score of an IP address to check for fraud / bots
 * @returns {Object}
 */
export async function getIpQualityScore() {
  let userAgent, language, isMobile
  if (isBrowser()) {
    userAgent = window.navigator.userAgent
    language = window.navigator.language
    isMobile = _isMobile()
  }

  const params = { userAgent, language, isMobile }

  try {
    // Get the IP Address
    const ipRes = await axios.get("https://api.ipify.org?format=json")
    const ip = ipRes.data.ip

    params.ip = ip

    const res = await axios.request({
      url: "/api/ipqs",
      params,
    })

    return {
      action: `IP_FRAUD_CHECK`,
      data: res.data,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `IP_FRAUD_CHECK`,
      error: error.response.data.error,
    }
  }
}
